/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import * as Yup from 'yup';
export class TagCategoryValidation {
  static yupColorSchema() {
    return Yup.string().trim().required().default('#000000');
  }
}
